var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouseIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38441 21.1676V40.7363C6.38441 41.4769 6.98478 42.0776 7.72503 42.0776H17.2842V25.3691C17.2842 24.8993 17.6655 24.5179 18.1354 24.5179H26.8395C27.3098 24.5179 27.6915 24.8993 27.6915 25.3691V42.0776H37.2499C37.9905 42.0776 38.5913 41.4769 38.5913 40.7363V21.1676L22.4877 9.77325L6.38403 21.1676H6.38441Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7205 17.7319L23.0381 3.09712C22.7081 2.8635 22.2667 2.8635 21.9371 3.09712L14.7465 8.18512V6.42525C14.7465 5.98312 14.388 5.62462 13.9459 5.62462H10.4163C9.97422 5.62462 9.61572 5.98312 9.61572 6.42525V11.8155L1.25435 17.7319C0.824599 18.036 0.722599 18.6307 1.02672 19.0605L2.1836 20.6955C2.48772 21.1252 3.08247 21.2272 3.51222 20.9231L22.4872 7.49662L41.4622 20.9231C41.892 21.2272 42.4867 21.1252 42.7909 20.6955L43.9477 19.0605C44.2519 18.6307 44.1499 18.036 43.7201 17.7319H43.7205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon2);
export default __webpack_public_path__ + "static/media/house_icon 2.070e6ed5aca84dce19fe32aef049309f.svg";
export { ForwardRef as ReactComponent };